import { initStitchesBackgroundColorListeners, doAjax, initColorSelect, fakeSelected } from './helper'
import { getCustomizedSeatImage } from './imagesLogicController'


const initSeatCustomizing = () => {
	const seatSelect = document.querySelector("input[name=frontseat]").value;
	const modelCategory = document.querySelector("input[name=modelcategory]").value;
	const q1dembossing = document.querySelector("input[name=q1dembossing]").value;
	
	const seatLeatherImg = document.querySelector('.display .image-wrap .item')
	const seatStitchImg = document.querySelector('.display .image-wrap .overlay')
	const seatBieseImg = document.querySelector('.display .image-wrap .overlay-2')
	const seatEmbossingImg = document.querySelector('.display .image-wrap .overlay-3')

	const leatherTiles = document.querySelectorAll('.leather-tiles .color')
	const bieseTiles = document.querySelectorAll('.biese-tiles .color')
	const embossingTiles = document.querySelectorAll('.embossing-tiles .color')
	const stitchTiles = document.querySelectorAll('.seam-tiles .color')
	const stitchPlusTiles = document.querySelectorAll('.seam-plus-tiles .color')
	
	const checkboxBiese = document.querySelector("input[name=biese]");
	const biese = document.getElementById("toggle_biese");
	
	const checkboxEmbossing = document.querySelector("input[name=embossing]");
	const embossing = document.getElementById("toggle_embossing");

	initColorSelect()
	initStitchesBackgroundColorListeners('frontseat-leather-tiles','frontseat-stitch-tiles')
	initStitchesBackgroundColorListeners('frontseat-leather-tiles','frontseat-embossing-tiles')
	onFirstLoadSetImages(seatLeatherImg, seatStitchImg, seatBieseImg, seatEmbossingImg, seatSelect);

	if(checkboxBiese) {
		if(checkboxBiese.checked) {
			if(modelCategory == 'Q8_etron') {
				doAjax({
					choose_seat_biese: 2
				})
			} else {
				doAjax({
					choose_seat_biese: 1
				})
			}
			biese.style.display = "block";
		}
		checkboxBiese.addEventListener('change', function() {
			if (this.checked) {
				biese.style.display = "block";
				setBieseImg(seatBieseImg,seatSelect) 
				if(modelCategory == 'Q8_etron') {
					doAjax({
						choose_seat_biese: 2
					})
				} else {
					doAjax({
						choose_seat_biese: 1
					})
				}
			} else {
				biese.style.display = "none";
				setEmptyImg(seatBieseImg)
				doAjax({
					choose_seat_biese: 0
				})
			}
		});
	}

	if(checkboxEmbossing) {
		if(checkboxEmbossing.checked) {
			embossing.style.display = "block";
		}
		checkboxEmbossing.addEventListener('change', function() {
			if (this.checked) {
				embossing.style.display = "block";
				setEmbossingImg(seatEmbossingImg,seatSelect) 
				doAjax({
					choose_seat_embossing: 1
				})
			} else {
				embossing.style.display = "none";
				setEmptyImg(seatEmbossingImg)
				doAjax({
					choose_seat_embossing: 0
				})
			}
		});
	}
	

	leatherTiles?.forEach(element => {
		element.addEventListener("click", function (e) {
			const selectedLeatherColor = document.querySelector('.leather-tiles .color.selected input').value
			seatLeatherImg.src = getCustomizedSeatImage('frontSeat', 'seatColor', selectedLeatherColor, seatSelect)
			seatStitchImg.src = getCustomizedSeatImage('frontSeat', 'stitchColor', selectedLeatherColor, seatSelect)

			// reload embossing only for Q1D Seat
			if(q1dembossing) {
				seatEmbossingImg.src = aeo['images']['frontseat_'+seatSelect+q1dembossing+'_color'][selectedLeatherColor];
			}

			fakeSelected("frontseat-stitch-tiles", selectedLeatherColor)
			fakeSelected("frontseat-stitch-plus-tiles", selectedLeatherColor)
			if(seatSelect.includes('Q2J') || seatSelect == 'Q1D_AU65X')  { // only if seat == INDIVIDUAL_SEAT
				seatBieseImg.src = getCustomizedSeatImage('frontSeat', 'bieseColor', selectedLeatherColor, seatSelect)
				fakeSelected("frontseat-biese-tiles", selectedLeatherColor)
			}
			if(seatSelect.includes('Q4Q_RS')) { // only if seat == Q4Q_RS Sport Seat
				seatEmbossingImg.src = getCustomizedSeatImage('frontSeat', 'embossingColor', selectedLeatherColor, seatSelect)
				fakeSelected("frontseat-embossing-tiles", selectedLeatherColor)
			}
			//save seat state 
			saveSeatWithAjax(selectedLeatherColor, selectedLeatherColor, selectedLeatherColor, selectedLeatherColor)
		});
	});

	stitchTiles?.forEach(element => {
		//when on click on stitch tile
		element.addEventListener("click", function (e) {
			const selectedLeatherColor = document.querySelector('.leather-tiles .color.selected input').value
			const selectedStitchColor = document.querySelector('.seam-tiles .color.selected input').value
			var selectedBieseColor = 8
			var selectedEmbossingColor = 8
			if (document.querySelector('.biese-tiles .color.selected input')) {
				var selectedBieseColor = document.querySelector('.biese-tiles .color.selected input').value
			}
			if (document.querySelector('.embossing-tiles .color.selected input')) {
				var selectedEmbossingColor = document.querySelector('.embossing-tiles .color.selected input').value
			}
			seatStitchImg.src = getCustomizedSeatImage('frontSeat', 'stitchColor', selectedStitchColor, seatSelect)
			saveSeatWithAjax(selectedLeatherColor, selectedStitchColor, selectedBieseColor, selectedEmbossingColor )
		});
	});

	bieseTiles?.forEach(element => {
		//when on click on biese tile
		element.addEventListener("click", function (e) {
			const selectedLeatherColor = document.querySelector('.leather-tiles .color.selected input').value
			const selectedStitchColor = document.querySelector('.seam-tiles .color.selected input').value
			const selectedBieseColor = document.querySelector('.biese-tiles .color.selected input').value
			seatBieseImg.src = getCustomizedSeatImage('frontSeat', 'bieseColor', selectedBieseColor, seatSelect)
			//save seat state 
			saveSeatWithAjax(selectedLeatherColor, selectedStitchColor, selectedBieseColor, selectedStitchColor, )
		});
	});

	embossingTiles?.forEach(element => {
		//when on click on embossing tile
		element.addEventListener("click", function (e) {
			const selectedLeatherColor = document.querySelector('.leather-tiles .color.selected input').value
			const selectedStitchColor = document.querySelector('.seam-tiles .color.selected input').value
			const selectedEmbossingColor = document.querySelector('.embossing-tiles .color.selected input').value
			seatEmbossingImg.src = getCustomizedSeatImage('frontSeat', 'embossingColor', selectedEmbossingColor, seatSelect)
			//save seat state 
			saveSeatWithAjax(selectedLeatherColor, selectedStitchColor, selectedStitchColor, selectedEmbossingColor)
		});
	});

	stitchPlusTiles?.forEach(element => {
		//when on click on stitchPlus tile
		element.addEventListener("click", function (e) {
			const selectedLeatherColor = document.querySelector('.leather-tiles .color.selected input').value
			const selectedStitchColor = document.querySelector('.seam-tiles .color.selected input')?.value || document.querySelector('.seam-plus-tiles .color.selected input')?.value || '-';
			//const selectedStitchColor = document.querySelector('.seam-tiles .color.selected input').value
			const selectedStitchPlusColor = document.querySelector('.seam-plus-tiles .color.selected input').value
			seatStitchImg.src = getCustomizedSeatImage('frontSeat', 'stitchColor', selectedStitchPlusColor, seatSelect)
			//save seat state 
			saveSeatWithAjax(selectedLeatherColor, selectedStitchPlusColor, selectedStitchPlusColor, selectedStitchPlusColor)
		});
	});

	var checked_leather = $('#frontseat-leather-tiles .color.leather.selected span').text();
	//var checked_stitch = $('#frontseat-stitch-tiles .color.seam.selected span').text();
	var checked_stitch = $('#frontseat-stitch-tiles .color.seam.selected span').text()|| '-';
	//var checked_stitch_plus = $('#frontseat-stitch-plus-tiles .color.seam.selected span').text();
	var checked_stitch_plus = $('#frontseat-stitch-plus-tiles .color.seam.selected span').text() || '-';
	var checked_biese = $('#frontseat-biese-tiles .color.leather.selected span').text();
	var checked_embossing = $('#frontseat-embossing-tiles .color.seam.selected span').text();
	
	$('#leather_headline').html(checked_leather);
	$('#leather_label').animate({ opacity: 1 }, 150);
	$('#stitch_headline').html(checked_stitch);
	$('#stitch_label').animate({ opacity: 1 }, 150);
	$('#stitch_plus_headline').html(checked_stitch_plus);
	$('#stitch_plus_label').animate({ opacity: 1 }, 150);
	$('#biese_headline').html(checked_biese);
	$('#biese_label').animate({ opacity: 1 }, 150);	
	$('#embossing_headline').html(checked_embossing);
	$('#embossing_label').animate({ opacity: 1 }, 150);

	$("#frontseat-leather-tiles input").click(function () {
		checked_leather = $('#frontseat-leather-tiles .color.leather.selected span').text();
		$('#leather_headline').html(checked_leather);
		$('#stitch_headline').html(checked_leather);
		$('#stitch_plus_headline').html('-');
		$('#biese_headline').html(checked_leather);
		$('#embossing_headline').html(checked_leather);
		$('#leather_label').animate({ opacity: 1 }, 150);
		document.getElementById("panel-1").checked = false;
	});

	$("#frontseat-stitch-tiles input").click(function () {
		checked_stitch = $('#frontseat-stitch-tiles .color.seam.selected span').text();
		$('#stitch_headline').html(checked_stitch);
		if ($('#stitch_plus_headline').length) {
			$('#stitch_plus_headline').html('-');
			$('#frontseat-stitch-plus-tiles .color.selected').removeClass('selected');
		}
		$('#stitch_label').animate({ opacity: 1 }, 150);
		document.getElementById("panel-2").checked = false;
	});
	
	$("#frontseat-biese-tiles input").click(function () {
		checked_biese = $('#frontseat-biese-tiles .color.leather.selected span').text();
		$('#biese_headline').html(checked_biese);
		$('#biese_label').animate({ opacity: 1 }, 150);
		document.getElementById("panel-3").checked = false;
	});

	$("#frontseat-embossing-tiles input").click(function () {
		checked_embossing = $('#frontseat-embossing-tiles .color.seam.selected span').text();
		$('#embossing_headline').html(checked_embossing);
		$('#embossing_label').animate({ opacity: 1 }, 150);
		document.getElementById("panel-4").checked = false;
	});

	$("#frontseat-stitch-plus-tiles input").click(function () {
		checked_stitch = $('#frontseat-stitch-plus-tiles .color.seam.selected span').text();
		$('#stitch_plus_headline').html(checked_stitch);
		$('#stitch_headline').html('-');
		$('#frontseat-plus-tiles .color.selected').removeClass('selected');
		$('#stitch_plus_label').animate({ opacity: 1 }, 150);
		document.getElementById("panel-2-plus").checked = false;
	});

	if(modelCategory == 'q7') {
		// 5/7-Seater
		//DISABLE BUTTONS 
		let submit = document.getElementById("navigation-submit-btn");
		let options = document.querySelectorAll(".sevenseater");
		submit.setAttribute("disabled", true);
		for (let option of options) {
			if (option.querySelector(".is-checked")) {
				submit.removeAttribute("disabled");
			}
			option.addEventListener("click", () => {
				submit.removeAttribute("disabled");
			});
		} 

		//SAVE STATE 
		const sevenseaters = document.querySelectorAll('.aui-radio.aui-js-radio input')
		sevenseaters.forEach(sevenseater => {
			sevenseater.addEventListener('click',(element)=>{
				doAjax({
					choose_seven_seater: element.target.value
				});
			})
		})
	}
	
}

function setEmptyImg(empyImg) {
	empyImg.src = 'img/03_sitze/front_empty.png'
}

function setBieseImg(seatBieseImg,seatSelect) {
	const selectedBieseColor = document.querySelector('.biese-tiles .color.selected input').value
	seatBieseImg.src = getCustomizedSeatImage('frontSeat', 'bieseColor', selectedBieseColor, seatSelect)
}

function setEmbossingImg(seatEmbossingImg,seatSelect) {
	const selectedEmbossingColor = document.querySelector('.embossing-tiles .color.selected input').value
	seatEmbossingImg.src = getCustomizedSeatImage('frontSeat', 'embossingColor', selectedEmbossingColor, seatSelect)
}

function onFirstLoadSetImages(seatLeatherImg, seatStitchImg, seatBieseImg, seatEmbossingImg, seatSelect) {
	const selectedLeatherColor = document.querySelector('.leather-tiles .color.selected input').value
	const selectedStitchColor = document.querySelector('.seam-tiles .color.selected input')?.value || document.querySelector('.seam-plus-tiles .color.selected input')?.value;
	const q1dembossing = document.querySelector("input[name=q1dembossing]").value;

	const checkboxBiese = document.querySelector("input[name=biese]");
	if(checkboxBiese && checkboxBiese.checked) {
		const selectedBieseColor = document.querySelector('.biese-tiles .color.selected input').value
		seatBieseImg.src = aeo['images']['frontseat_'+seatSelect+'_biese_color'][selectedBieseColor];
	}

	const checkboxEmbossing = document.querySelector("input[name=embossing]");
	if(checkboxEmbossing  && checkboxEmbossing.checked) {
		const selectedEmbossingColor = document.querySelector('.embossing-tiles .color.selected input').value
		seatEmbossingImg.src = aeo['images']['frontseat_'+seatSelect+'_embossing_color'][selectedEmbossingColor];
	}

	// reload embossing only for Q1D Seat
	if(q1dembossing) {
		seatEmbossingImg.src = aeo['images']['frontseat_'+seatSelect+q1dembossing+'_color'][selectedLeatherColor];
	}

	//set leather and stitch images
	var carmodel = document.querySelector("input[name=carmodel]").value;
	if ((carmodel == 2) || (carmodel == 200)) {
		seatLeatherImg.src = aeo['images']['frontseat_RS_'+seatSelect+'_color'][selectedLeatherColor];
	} else if (carmodel == 1) {
		seatLeatherImg.src = aeo['images']['frontseat_S_'+seatSelect+'_color'][selectedLeatherColor];
	} else {
		seatLeatherImg.src = aeo['images']['frontseat_'+seatSelect+'_color'][selectedLeatherColor];
	}
	
	seatStitchImg.src = aeo['images']['frontseat_'+seatSelect+'_stitch_color'][selectedStitchColor];
}

function saveSeatWithAjax(seatColor,seatStitch,bieseColor,embossingColor) {
	doAjax({
		'individual-frontseat' : true,
		'seat-color': seatColor,
		'seat-stitch': seatStitch,
		'biese-color': bieseColor,
		'embossing-color': embossingColor
	}, (response) => {
	})
}


export { initSeatCustomizing };
